"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "appendNodeAsync", {
  enumerable: true,
  get: function get() {
    return _domOps.appendNodeAsync;
  }
});
Object.defineProperty(exports, "createElement", {
  enumerable: true,
  get: function get() {
    return _domOps.createElement;
  }
});
Object.defineProperty(exports, "cacheAll", {
  enumerable: true,
  get: function get() {
    return _utils.cacheAll;
  }
});
exports.importStyle = exports.importScript = exports.appendScript = exports.appendStyle = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _domOps = require("./dom-ops");

var _utils = require("./utils");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var appendStyle = function appendStyle(href, nodeProps) {
  var resolveCallback = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : (0, _utils.onlyIfFn)(nodeProps);
  return (0, _domOps.appendNodeAsync)(global.document.head, (0, _domOps.createElement)('link', _objectSpread({
    rel: 'stylesheet',
    href: href
  }, (0, _utils.onlyIfNotFn)(nodeProps))), resolveCallback);
};

exports.appendStyle = appendStyle;

var appendScript = function appendScript(src, nodeProps) {
  var resolveCallback = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : (0, _utils.onlyIfFn)(nodeProps);
  return (0, _domOps.appendNodeAsync)(global.document.body, (0, _domOps.createElement)('script', _objectSpread({
    type: 'text/javascript',
    async: true,
    src: src
  }, (0, _utils.onlyIfNotFn)(nodeProps))), resolveCallback);
};

exports.appendScript = appendScript;
var importScript = (0, _utils.cacheAll)(appendScript);
exports.importScript = importScript;
var importStyle = (0, _utils.cacheAll)(appendStyle);
exports.importStyle = importStyle;